import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const ForgotPassword = lazy(
  () => import('@pages/dashboard/ForgotPassword/index'),
);

const EnterUsername = lazy(
  () => import('@pages/dashboard/ForgotPassword/components/EnterUsername'),
);

const ResetPassword = lazy(
  () => import('@pages/dashboard/ForgotPassword/components/ResetPassword'),
);

export const ForgotPasswordRoutes: RouteObject[] = [
  {
    path: '/forgot-password',
    element: (
      <React.Suspense>
        <ForgotPassword />
      </React.Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <React.Suspense>
            <EnterUsername />
          </React.Suspense>
        ),
      },
      {
        path: 'reset',
        element: (
          <React.Suspense>
            <ResetPassword />
          </React.Suspense>
        ),
      },
    ],
  },
];
